import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input"];

    connect() {
        const input = this.hasInputTarget
          ? this.inputTarget
          : this.element.querySelector("input, textarea, select, [tabindex]:not([tabindex='-1'])");

        if (!input) return;

        requestAnimationFrame(() => input.focus());
    }

}
